import Notification from '@rio-cloud/rio-uikit/Notification';
import { useExtendFreeTrialMutation } from '../api/freetrial/freeTrialApiSlice';
import { getApiErrorMessage } from '../api/apiError';

type ExtendFreeTrialPayload = {
    accountId: string;
    endsAt: string;
    reason: string;
};

export function useExtendFreeTrialAction() {
    const [extendFreeTrial, { isLoading }] = useExtendFreeTrialMutation();

    const execute = async ({ accountId, endsAt, reason }: ExtendFreeTrialPayload) => {
        try {
            await extendFreeTrial({ accountId, endsAt, reason }).unwrap();
            Notification.success('Free trial extended successfully');
            return true;
        } catch (e) {
            const errorMessage = getApiErrorMessage(e);
            Notification.error(`Could not execute free-trials service: ${errorMessage}`);
            return false;
        }
    };

    return {
        extendFreeTrial: execute,
        isLoading,
    };
}
